





















import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';

// directly exposed from vuetify/types no intention to change
import { InputMessage, InputValidationRules } from 'vuetify/types';
import { IUser } from '@/models';

export type EmployeeUserPickerType = (number | IUser)[] | number | IUser;

export default Vue.extend({
  name: 'EmployeeUserPicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Array, Number, Object] as PropType<EmployeeUserPickerType>,

    externalErrorMessage: {
      type: [String, Array] as PropType<string | string[]>,
      default: () => []
    },

    clearable: {
      type: Boolean,
      default: () => true
    }
  },

  data() {
    return {
      lazyValue: this.value,
      search: '',
      errorMessage: '',
      page: 1,
      loading: false
    };
  },

  watch: {
    value: {
      handler(val: any) {
        this.lazyValue = val;
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters({
      salaryEmployeeUsers: 'employee/getSalaryEmployeeUsers'
    }),

    internalValue: {
      get(): EmployeeUserPickerType {
        return this.lazyValue;
      },
      set(val: EmployeeUserPickerType) {
        this.lazyValue = val;
        this.$emit('input', val);
        this.$emit('change', val);
      }
    },

    customAttrs(): object {
      return this.$attrs;
    },

    internalMessages(): InputValidationRules {
      if (!this.externalErrorMessage) {
        return [];
      } else if (Array.isArray(this.externalErrorMessage)) {
        return this.externalErrorMessage;
      } else {
        return [this.externalErrorMessage];
      }
    },

    errorMessageList(): InputValidationRules {
      const errorList = this.internalMessages;
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    this.loading = true;
    this.fetchSalaryEmployeeUsers()
      .catch(error => {
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapActions({
      fetchSalaryEmployeeUsers: 'employee/fetchSalaryEmployeeUsers'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
    }
  }
});
